// ======================================================
// VIDÉOS DE REPLI MOVIEFRENZY
// ======================================================
// Ces vidéos sont utilisées lorsque TMDB ne fournit
// aucune vidéo exploitable pour le film concerné.
//
// Clé principale : identifiant TMDB du film.

const MOVIE_VIDEO_FALLBACKS = {
    // Rédemptions — Luc Picard
    1705737: [
        {
            id: "mf-redemptions-trailer-fr",
            key: "9h_CDwQBJ7w",
            name: "RÉDEMPTIONS un film de Luc Picard | Bande-annonce officielle",
            site: "YouTube",
            type: "Trailer",
            official: true,
            iso_639_1: "fr",
            iso_3166_1: "CA",
            size: 1080,
            published_at: "2026-05-14T00:00:00.000Z",
            movieFrenzySource: "Les Films Opale",
        },
        {
            id: "mf-redemptions-teaser-fr",
            key: "kvSkm9raTmE",
            name: "RÉDEMPTIONS un film de Luc Picard | Pré-bande-annonce",
            site: "YouTube",
            type: "Teaser",
            official: true,
            iso_639_1: "fr",
            iso_3166_1: "CA",
            size: 1080,
            published_at: "2026-02-13T00:00:00.000Z",
            movieFrenzySource: "Les Films Opale",
        },
    ],
};

export const getMovieVideoFallbacks = (tmdbId) => {
    const videos =
        MOVIE_VIDEO_FALLBACKS[Number(tmdbId)] || [];

    return [...videos];
};